import {ISkeleton} from '../../interfaces/skeleton';
import {SkeletonTypeEnum} from '../../enums/skeleton';

export const StatisticsSkeleton: ISkeleton[] = [
  {
    multiple: false,
    type: SkeletonTypeEnum.TEXT,
    style: 'width: 50%',
    rows: 0
  },
  {
    multiple: true,
    style: 'width: 100%; flex-wrap: nowrap',
    items: [
      {
        type: SkeletonTypeEnum.INPUT,
        style: 'width: 33%; height: 150px;',
        classes: 'mr-xlg'
      },
      {
        type: SkeletonTypeEnum.INPUT,
        style: 'width: 33%; height: 150px;',
        classes: 'mr-xlg'
      },
      {
        type: SkeletonTypeEnum.INPUT,
        style: 'width: 33%; height: 150px;',
      }
    ]
  },
  {
    multiple: true,
    style: 'width: 100%; flex-wrap: nowrap',
    classes: 'mt-xlg',
    items: [
      {
        type: SkeletonTypeEnum.INPUT,
        style: 'width: 50%; height: 350px;',
        classes: 'mr-xlg'
      },
      {
        type: SkeletonTypeEnum.INPUT,
        style: 'width: 50%; height: 350px;',
      }
    ]
  },
  {
    multiple: true,
    style: 'width: 100%; flex-wrap: nowrap',
    classes: 'mt-xlg',
    items: [
      {
        type: SkeletonTypeEnum.INPUT,
        style: 'width: 50%; height: 350px;',
        classes: 'mr-xlg'
      },
      {
        type: SkeletonTypeEnum.INPUT,
        style: 'width: 50%; height: 350px;',
      }
    ]
  }
];
